import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";

const Footer = () => {
  const current_year = new Date().getFullYear();
  return (
    <>
      <div className="footer padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-sm-6 col-xs-12">
              <Link to="/">
                <div className="ftr-logo">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/ftr-logo.png"
                      className="img-fluid"
                      alt="St. Joseph’s school, Barhalganj"
                    />
                  </LazyLoad>
                  <div>
                    <div className="social-media">
                      <p>
                        <i class="bi bi-instagram"></i>
                      </p>
                      <p>
                        <i class="bi bi-linkedin"></i>
                      </p>
                      <p>
                        <i class="bi bi-facebook"></i>
                      </p>
                      <p>
                        <i class="bi bi-youtube"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-xl-6 col-lg-6 col-sm-6 col-xs-12">
              <div className="quick-link">
                <ul>
                  <li>
                    <Link to="/">
                      <i class="bi bi-caret-right-fill"></i> Infrastructure
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <i class="bi bi-caret-right-fill"></i> Academic calender
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <i class="bi bi-caret-right-fill"></i> Co-Curricular
                      Activities
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <i class="bi bi-caret-right-fill"></i> Achievements
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i>News
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i> Events
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i> Alumnae
                      Registration
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i> Conduct and
                      Discipline
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i> Curriculum
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i> Mission Statement
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i> School Motto
                    </Link>
                  </li>
                  <li>
                    <Link to="/" target="_blank">
                      <i class="bi bi-caret-right-fill"></i> Book List
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6 col-sm-6 col-xs-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3577.2939324500594!2d83.5066215!3d26.284569699999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399178b2a9eaf059%3A0xc2de2bbbe26a80e0!2sST.%20JOSEPH&#39;S%20SCHOOL%20Barhalganj!5e0!3m2!1sen!2sin!4v1760347218643!5m2!1sen!2sin"
                width="100%"
                height="200px"
                frameborder="0"
                allowfullscreen=""
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        ©️ {current_year} Copyright, All Right Reserved. St. Joseph’s School,
        Barhalganj | Designed and Developed By
        <Link to="https://www.entab.in/" target="_blank">
          &nbsp; Entab Infotech Pvt. Ltd. <sup>®️ </sup>
        </Link>
      </div>
    </>
  );
};

export default Footer;
